import { render } from "./Composer.vue?vue&type=template&id=bc919882&scoped=true&ts=true"
import script from "./Composer.vue?vue&type=script&lang=ts"
export * from "./Composer.vue?vue&type=script&lang=ts"

import "./Composer.vue?vue&type=style&index=0&id=bc919882&lang=css"
import "./Composer.vue?vue&type=style&index=1&id=bc919882&scoped=true&lang=css"

import exportComponent from "/Users/georgemayer/Sites/apps/lognote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc919882"]])

export default __exports__